/**
 * shirt.ts — regras de domínio da camisa UV, COMPARTILHADAS entre client e server
 * (fonte única de verdade). O front (React) e o back (Zod) validam com as mesmas regras.
 */
export const SHIRT_NAME_MAX = 18;
// letras (com acentos), números, espaço, hífen e apóstrofo. Sem emoji/controle.
const NAME_RE = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 '-]+$/;
/** Valida o "Nome na Camisa". Mesma regra no client e no server. */
export function validateShirtName(raw) {
    const nome = raw.trim();
    if (nome.length === 0)
        return { ok: false, motivo: 'Informe o nome que vai na camisa.' };
    if (nome.length > SHIRT_NAME_MAX)
        return { ok: false, motivo: `Máximo de ${SHIRT_NAME_MAX} caracteres.` };
    // rejeita caracteres de controle e emoji (fora do intervalo permitido)
    if (!NAME_RE.test(nome))
        return { ok: false, motivo: 'Use apenas letras, números, espaço, hífen e apóstrofo.' };
    return { ok: true };
}
/** Normaliza para renderização (maiúsculas), preservando o original no banco. */
export function shirtNameForRender(raw) {
    return raw.trim().toUpperCase();
}
export const SHIRT_POSITIONS = ['BACK', 'CHEST'];
//# sourceMappingURL=shirt.js.map